import React from 'react';
import { DataSourceManagement } from '../features/datasources';

/**
 * DataSourcesPage - Admin data sources management page
 */
export const DataSourcesPage: React.FC = () => {
  return <DataSourceManagement />;
};

export default DataSourcesPage;
